import { __assign } from "tslib";
import { useEffect } from 'react';
import { logToAPI } from './logToAPI';
import { TrackError } from './eventLoggerFunctions';
export function useCDNTrackingToLogs(_a) {
    var isLoading = _a.isLoading, data = _a.data, version = _a.version, projectKey = _a.projectKey, error = _a.error, isMobile = _a.isMobile, userId = _a.userId, sessionId = _a.sessionId, domainScopedSessionId = _a.domainScopedSessionId, clientId = _a.clientId, _b = _a.pageUrl, pageUrl = _b === void 0 ? '' : _b, _c = _a.eventLoggerUrl, eventLoggerUrl = _c === void 0 ? '' : _c, _d = _a.eventLoggerApiKey, eventLoggerApiKey = _d === void 0 ? '' : _d, _e = _a.isPreview, isPreview = _e === void 0 ? false : _e;
    var CDNTrackingParameters = {
        version: version,
        projectKey: projectKey,
        data: data,
        isMobile: isMobile,
        userId: userId,
        sessionId: sessionId,
        domainScopedSessionId: domainScopedSessionId,
        clientId: clientId,
        pageUrl: pageUrl,
        eventLoggerUrl: eventLoggerUrl,
        eventLoggerApiKey: eventLoggerApiKey,
        isPreview: isPreview,
    };
    useEffect(function () {
        var isError = !isLoading && error;
        var isEmpty = !isLoading && !error && data.length === 0;
        if (isError) {
            TrackError(__assign({ screen: 'CDN', action: 'ERROR', error: error }, CDNTrackingParameters));
        }
        if (isEmpty) {
            logToAPI(__assign({ screen: 'CDN', action: 'NO_RESPONSE' }, CDNTrackingParameters));
        }
    }, [isLoading, error]);
}
